var React = require('react');

function Staff (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M369.9 284.81l32.25 18.62a16 16 0 0 0 21.85-5.86l19.54-33.79zM96 304v44.1l60.13-60.1H112a16 16 0 0 0-16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 80v103.86a80 80 0 0 1-58 76.92l-168.92 48.27a80.11 80.11 0 0 0-34.62 20.37L74.91 505A24 24 0 0 1 41 505L7 471a24 24 0 0 1 0-33.9L156.13 288l26.48-26.48a176.06 176.06 0 0 1 76.11-44.78L416 171.8V96h-50.32l-11.58 23.15a16 16 0 0 1-21.46 7.16l-57.26-28.63a16 16 0 0 1-7.15-21.46l16-32A80 80 0 0 1 355.78 0H432a80 80 0 0 1 80 80z","className":"fa-primary","key":2})]);
}

Staff.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Staff;

Staff.default = Staff;
